import LazyLoad from 'react-lazyload';
import React, { useState } from 'react';
import { PatientSubscriptionSummaryProps } from './patient-subscription-summary.props';
import {
  formatCurrency,
  getTrialRenewalDate,
  storeRegion,
} from '../../../utils';
import { CatalogPlanLocalePrice } from '@hiwaldo/sdk/interfaces';
import { AccountQAStyles } from '../../../styles/organisms/account-quick-actions.styles';
import { plansSum } from '../../../data/subscription/plan-type';
import { HydraboostProductSummaryMolecule } from '../../molecules/hydraboost-product-summary/hydraboost-product-summary.molecule';
import { DropsProductSummaryMolecule } from '../../molecules/drops-product-summary';
import { PromotionProductSummaryMolecule } from '../../molecules/promotion-product-summary';

export const PatientSubscriptionSummaryOrganism = (
  props: PatientSubscriptionSummaryProps
) => {
  const plan = props.cart.trials[0].trial.plans[0];
  let trial = {} as CatalogPlanLocalePrice;

  const leadTime = props.cart.trials[0].trial.locales[0].leadTime;
  const nextOrderDate = getTrialRenewalDate(leadTime);

  const region = storeRegion();
  for (const i in plan.plan.locales) {
    if ((plan.plan.locales[i].region as string) === (region as string)) {
      trial = plan.plan.locales[i];
      break;
    }
  }
  const classes = AccountQAStyles();
  const [showPopup, setShowPopup] = useState(false);

  function enableShowPopup() {
    setShowPopup(!showPopup);
  }

  return (
    <div
      data-cy="checkout-subscription-summary-organism"
      className="bg-waldo-light-blue p-5 mx-auto lg:mx-0 rounded-lg mb-3 mt-5 lg:mt-0"
    >
      <h2 className="text-base font-waldo-sans font-semibold md:text-lg">
        Subscription summary
      </h2>
      <p className="text-base font-waldo-sans mb-3 md:text-lg">
        After your trial, your next order will ship on {nextOrderDate}. Modify,
        pause or cancel in your account, it&apos;s hassle free.
      </p>
      <div className="py-2.5 px-3 bg-waldo-lighter-blue rounded-lg">
        <div className="text-center w-full mx-auto list-none">
          <div className="flex justify-between mb-2">
            <h3 className="text-base font-waldo-sans font-semibold md:text-lg">
              {plan.plan.planFamily.title} Plan
            </h3>
            <div
              className="cursor-pointer ml-1 relative self-center"
              onClick={() => enableShowPopup()}
            >
              <img className="w-4 h-4" src="/images/icons/more-info-icon.svg" />
              <div
                className={`${
                  classes.arrowUp
                } z-40 shadow-md absolute top-4 -left-1 ${
                  showPopup === true ? 'block' : 'hidden'
                }`}
              ></div>
              <div
                className={`absolute bg-white rounded-lg w-80 h-52 -left-72 shadow-md z-40 top-6 py-5 px-3 flex flex-col items-center ${
                  showPopup === true ? 'block' : 'hidden'
                }`}
              >
                <h3 className="text-base font-waldo-sans font-semibold pb-3">
                  What other plans are available?
                </h3>
                <div className="flex items-baseline w-full">
                  {plansSum.map((plan, index) => (
                    <div
                      key={index}
                      className="flex flex-row w-full items-center justify-center"
                    >
                      <div
                        className={`flex flex-col items-center justify-center`}
                      >
                        <img
                          className={plan.imageStyle}
                          src={plan.image}
                          alt={plan.alt}
                        />
                        <div className="">
                          <p className="text-sm font-bold">{plan.paraOne}</p>
                          <p className="text-sm font-bold">{plan.paraTwo}</p>
                          <p className="text-sm font-bold">{plan.paraThree}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <span className="flex flex-row items-center text-left mx-auto justify-start">
            <LazyLoad offset={100}>
              <img
                src="/images/icons/arrow-circle.svg"
                alt="recurring arrows"
                width={15}
                height={15}
              />
            </LazyLoad>
            <p className="ml-2 text-base font-waldo-sans md:text-lg">
              Delivery every 3 months
            </p>
          </span>
        </div>
        <HydraboostProductSummaryMolecule />
        <DropsProductSummaryMolecule />
        <PromotionProductSummaryMolecule />
      </div>
      <div className="py-3 w-full border-b border-border-blue">
        <div className="total flex justify-between font-waldo-sans text-small mb-3">
          <p className="text-base font-waldo-sans md:text-lg">Subtotal</p>
          <p className="text-base font-waldo-sans md:text-lg">
            {formatCurrency(trial.actualPrice, 2, 2)}
          </p>
        </div>
        <div className="total flex justify-between font-waldo-sans text-small mb-1">
          <p className="text-base font-waldo-sans md:text-lg">Shipping</p>
          <p className="text-base font-waldo-sans md:text-lg">$0.00</p>
        </div>
      </div>

      <div className="total w-full flex justify-between font-waldo-sans pt-3 text-small">
        <div>
          <p className="font-waldo-sans font-semibold text-xl md:text-xl">
            Due {nextOrderDate}
          </p>
        </div>
        <div className="flex">
          <span className="text-waldo-blue font-medium text-xl md:text-xl line-through block inline-block px-1">
            <p className="font-waldo-sans text-border-blue font-semibold text-xl md:text-xl">
              {formatCurrency(trial.basePrice, 2, 2)}
            </p>
          </span>
          <p className="font-waldo-sans font-semibold text-xl md:text-xl">
            {formatCurrency(trial.actualPrice, 2, 2)}
          </p>
        </div>
      </div>
    </div>
  );
};
